// A container, so argument rows can stack when the block is narrow.
export const BLOCK = '@container flex flex-col gap-3 rounded-xl border bg-white p-4 shadow-[0_1px_2px_rgba(16,24,40,0.06)] transition-[border-color,box-shadow]';
export const FOCUSED = 'border-indigo-500 ring-4 ring-indigo-500/15';
